import React, {useEffect, useRef, useState} from "react";
import {PenIconSession} from "../../../../assets/icons/defaultIcons";
import {formateDate} from "../../../utils/constant";
import {useNavigate} from "react-router-dom";
import './PreviousSession.scss'; // Add this import for custom CSS

const DespFunc = ({ des, isExpanded, setIsTruncated }) => {
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            const lines = Math.ceil(contentRef.current.scrollHeight / parseFloat(getComputedStyle(contentRef.current).lineHeight));
            setIsTruncated(lines > 5); // Check if content exceeds 5 lines
        }
    }, [des, setIsTruncated]);

    return (
        <div
            ref={contentRef}
            className={`content ${isExpanded ? "expanded" : "truncated"}`}
            style={{
                maxHeight: isExpanded ? "none" : "calc(1.2em * 5)", // Approximate line height for 5 lines
                overflow: "hidden",
            }}
        >
            {des?.split(/\n{2,}/)?.map((para, paraIndex) => (
                <React.Fragment key={paraIndex}>
                    {para.split("\n").map((line, lineIndex) => (
                        <React.Fragment key={`${paraIndex}-${lineIndex}`}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                    <br />
                </React.Fragment>
            ))}
        </div>
    );
};

const PreviousSession = ({ Data, setSessionEdit, open }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const contentRef = useRef(null);
    const navigate = useNavigate();

    // Check if content is long enough to be truncated
    useEffect(() => {
        if (contentRef.current) {
            // Check if the content is taller than our max height
            setIsTruncated(contentRef.current.scrollHeight > 200);
        }
    }, [Data?.sessionNote]);

    const toggleReadMore = () => {
        setIsExpanded((prev) => !prev);
    };

    const HandleValueOfSeesion = () => {
        setSessionEdit(Data);
        open(true);
    };


    return (
        <div className="previous_session_listing">
            <p>Date: {formateDate(Data?.updatedAt)}</p>
            <div className="content_div_main">
                <div className="inner_div_content">
                    <div 
                        className={`html-content-wrapper ${isExpanded ? 'expanded' : ''}`}
                        style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                        dangerouslySetInnerHTML={{ __html: Data?.sessionNote || '' }}
                        ref={contentRef}
                    />

                    <div className="content-actions">
                       

                        <span className="edit-icon" onClick={HandleValueOfSeesion}>
                            <PenIconSession />
                        </span>
                    </div>
                    
                </div>
                 {isTruncated && (
                            <span className="toggle-read-more" onClick={toggleReadMore}>
                                {isExpanded ? "Read Less" : "Read More"}
                            </span>
                        )}
            </div>
        </div>
    );
};

export default PreviousSession;
